import { render, staticRenderFns } from "./IngresanteFormCursado.vue?vue&type=template&id=eb2d264a&scoped=true&"
import script from "./IngresanteFormCursado.vue?vue&type=script&lang=js&"
export * from "./IngresanteFormCursado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2d264a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
